import { css, keyframes } from "@emotion/react"

type Props = {
  size: "small" | "medium"
  color: "blue" | "white"
}

const Spinner = ({ size, color }: Props) => {
  const style = css`
    width: ${sizeSet[size].width}px;
    height: ${sizeSet[size].height}px;
    border-radius: 50%;
    border: ${sizeSet[size].lineThickness}px solid ${colors[color]}20;
    border-left-color: ${colors[color]};
    animation: ${bounce} 0.9s infinite linear;
  `

  return <div css={style} />
}

export default Spinner

const colors = {
  blue: "#1f5da0",
  white: "#ffffff",
}

const sizeSet = {
  small: {
    width: 20,
    height: 20,
    lineThickness: 3,
  },
  medium: {
    width: 80,
    height: 80,
    lineThickness: 6,
  },
}

const bounce = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`
